import React from "react";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ManualPurchaseOrder } from "../../api/manualPurchaseOrder";
import { AddAssetsStep } from "../add-assets-step";
import { PurchaseOrderForm } from "./purchase-order-form";
import { useLinked } from "@type-r/react";
import { Company } from "../../api/company";

export const AddPurchaseOrdersStep = ({ next, back, cancel, job }:
    { next?, back?, cancel?, job: IngestionJob }) => {
    const $dataHolderId = useLinked<Company>(new Company());    
    return <>
        <AddAssetsStep
            assetName="Purchase Order"
            allowedExtension="*.pdf"
            jobInfoProvider={() => ({ ...DocumentSource.PurchaseOrder })}
            $dataHolderId={$dataHolderId}
            assetForm={manualPurchaseOrder => <PurchaseOrderForm purchaseOrder={manualPurchaseOrder}></PurchaseOrderForm>}
            manualAssetModel={ManualPurchaseOrder}
            next={next} back={back} cancel={cancel} job={job} />
    </>
};
